import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button } from '../../components';
import Masks from '../../utils/masks';
import {
  tipoRequerimentoFilter,
} from '../../utils/listsSelect';
import { trataMensagensErro } from '../../utils/requests';

class FiltroCessacao extends Component {
  constructor() {
    super();

    this.filtroCessacao = JSON.parse(sessionStorage.getItem('filtroCessacao'));

    this.state = {
      cpf:
        this.filtroCessacao && this.filtroCessacao.cpf ?
          this.filtroCessacao.cpf : null,
      tipoRequerimento:
        this.filtroCessacao && this.filtroCessacao.tipoRequerimento ?
          this.filtroCessacao.tipoRequerimento : null,
      filtro:
        this.filtroCessacao && this.filtroCessacao.filtro ?
          this.filtroCessacao.filtro : null,
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroCessacao')) {
      this.handleSearchButton();
    }
  }

  componentDidUpdate(prevProps) {
    // Apenas repete consulta se parametro da url for alterado
    if (this.props.tipoConsulta !== prevProps.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }

  preparaNovaConsulta = () => {
    let filtroCessacao = {
      cpf: null,
      tipoRequerimento: null,
    };

    filtroCessacao = JSON.stringify(filtroCessacao);
    sessionStorage.setItem('filtroCessacao', filtroCessacao);

    this.setState({
      cpf: null,
      tipoRequerimento: null,
    });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleSearchButton = () => {
    let filtroCessacao = {
      cpf: this.state.cpf,
      tipoRequerimento: this.state.tipoRequerimento,
    };
    filtroCessacao = JSON.stringify(filtroCessacao);
    sessionStorage.setItem('filtroCessacao', filtroCessacao);
    this.setState(
      {
        cliqueiNoBotao: 1,
      },
      () => {
        this.handleChange({
          value: 1,
          isValid: true,
        }, 'cliqueiNoBotao');
      },
    );

    this.handleSearch();
  }

  handleListFilter = () => {
    let listaFiltrada = this.props.list;

    if (this.state.filtraExigenciaHomologacao) {
      listaFiltrada = listaFiltrada.filter((requerimento) => {
        const exigenciasDiferentesHomologacao = requerimento.exigencias
          .filter(exigencia => exigencia.tipo !== (6 || 23));
        if (exigenciasDiferentesHomologacao.length > 0) return true;
        return false;
      });
    }
    this.props.handleChangeList(listaFiltrada);
  }

  handleSearch = () => {
    if (this.state.cpf || this.state.tipoRequerimento) {
      this.props.handleSearchFilter(this.state);
    } else {
      trataMensagensErro(['Escolha pelo menos um filtro de CPF ou de Tipo de Requerimento para a consulta']);
    }
  }

  render() {
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          <div className="row">
            <Grid cols="2 2 2 2">
              <Input
                cpf
                integer
                label="CPF"
                mask={Masks.cpf}
                onChange={e => this.handleChange(e, 'cpf')}
                showMask
                value={this.state.cpf}
                validationState="active"
              />
            </Grid>
            <Grid cols="3 3 3 3">
              <Input
                label="Tipo de Requerimento"
                name="tipoRequerimento"
                onChange={e => this.handleChange(e, 'tipoRequerimento')}
                itemList={tipoRequerimentoFilter}
                radio
                value={this.state.tipoRequerimento}
                validationState="active"
                custom
              />
            </Grid>
          </div>

          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroCessacao.propTypes = {
  destinatarios: PropTypes.arrayOf().isRequired,
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  tipoConsulta: PropTypes.string,
}.isRequired;

export default FiltroCessacao;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroCessacao.jsx